import { useCallback } from 'react'
import { NyuLineProperties, NyuSeriesProperties } from '../../../shared/types'
import { resolveSeriesKey } from '../utils/helpers'

export default function useGetLineData(seriesProperties: NyuSeriesProperties) {
    return useCallback(
        (someDataKey: string) => {
            const seriesKey = resolveSeriesKey(someDataKey, seriesProperties)
            const lineProps: NyuLineProperties = seriesProperties.find(
                (item) => item.key === seriesKey
            )!
            return lineProps
        },
        [seriesProperties]
    )
}
